import Promise from 'bluebird';
import { getFacebookConfig } from './get-facebook-config';

const fbSdkScriptId = 'facebook-js-sdk';

function loadScriptAsynchronously(id, src) {
  return new Promise((resolve) => {
    const fbScript = document.getElementById(id);
    // script already loaded, remove it and load again
    if (fbScript) {
      fbScript.parentNode.removeChild(fbScript);
    }

    // create a <script> element to load SDK
    const element = document.createElement('script');
    element.id = id;
    element.src = src;
    element.async = true;
    element.onload = resolve;
    document.body.appendChild(element);
  });
}

export function loadFacebookSdk() {
  const { appId, sdkUrl, sdkVersion } = getFacebookConfig(document.domain);

  // check if already initialize the FB SDK with a different appId
  // if so, we need to remove the sdk first
  if (window.fbAppIdInUse && window.fbAppIdInUse !== appId) {
    if (document.getElementById(fbSdkScriptId)) {
      document.getElementById(fbSdkScriptId).remove();
    }
    window.fbAsyncInit = undefined;
    window.FB = undefined;
    window.fbAppIdInUse = undefined;
  }

  // already loaded
  if (window.fbAsyncInit && window.fbAsyncInit.done && window.FB) {
    return Promise.resolve(window.FB);
  }

  const fbInitPromise = new Promise((resolve) => {
    // setup the initialization callback
    window.fbAsyncInit = () => {
      window.FB.init({
        appId,
        status: true,
        xfbml: false,
        version: sdkVersion,
      });

      // init complete
      window.fbAsyncInit.done = true;
      resolve(window.FB);
    };
  }).timeout(120000, 'FB API not inited in 2 minutes');

  const loadFBScriptPromise = loadScriptAsynchronously(fbSdkScriptId, sdkUrl);

  return Promise.all([fbInitPromise, loadFBScriptPromise])
    .then(() => { window.fbAppIdInUse = appId; })
    .then(() => window.FB)
    .catch((error) => {
      // if we are in production/SI
      if (sdkUrl.indexOf('debug.js') < 0) {
        throw error;
      }
    });
}
